export enum DocumentContentType {
  DOCUMENT,
  PHOTO,
}
